/*
 * PDP tab blocks ([data-pdp-tabs]): Shipping / View In Showrooms and
 * Complete The Room / Similar Products. Styles: assets/pdp-product.css ("pdp-tabs" part).
 *
 * All panels and their content are server-rendered; without JS they simply
 * stack. This adds tab switching only: one delegated listener for click and
 * arrow keys that flips aria-selected, tabindex and the panels' data-active.
 * CSS animates the height change. Nothing measures layout.
 */
(() => {
  if (window.pdpTabsReady) return;
  window.pdpTabsReady = true;

  function tabsOf(tab) {
    const group = tab.closest('[data-pdp-tabs]');
    return group ? Array.from(group.querySelectorAll('[role="tab"]')) : [];
  }

  function select(tab) {
    tabsOf(tab).forEach((other) => {
      const selected = other === tab;
      other.setAttribute('aria-selected', String(selected));
      other.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(other.getAttribute('aria-controls'));
      if (panel) panel.toggleAttribute('data-active', selected);
    });
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-pdp-tabs] [role="tab"]');
    if (tab) select(tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-pdp-tabs] [role="tab"]');
    if (!tab) return;
    const tabs = tabsOf(tab);
    const index = tabs.indexOf(tab);
    let next;
    if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
    else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
    else if (event.key === 'Home') next = tabs[0];
    else if (event.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;
    event.preventDefault();
    select(next);
    next.focus();
  });
})();
